module.exports = __webpack_public_path__ + "static/media/Transaction-risk-engine dashboard.4e0594e6.png";